import { render, staticRenderFns } from "./BuyVipDialog.vue?vue&type=template&id=554d6d3a&scoped=true"
import script from "./BuyVipDialog.vue?vue&type=script&lang=js"
export * from "./BuyVipDialog.vue?vue&type=script&lang=js"
import style0 from "./BuyVipDialog.vue?vue&type=style&index=0&id=554d6d3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554d6d3a",
  null
  
)

export default component.exports